<template>
  <FormProgress class="!mb-6" />

  <div class="text-3xl sm:text-4xl text-center">
    Continúa abajo para comparar planes en tu área.
  </div>

  <div class="min-h-md">
    <MediaAlphaAds :user="{}" />
  </div>
</template>
